"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Authenticator = void 0;
const common_1 = require("./common");
class Authenticator extends common_1.AbstractAuthenticator {
    constructor(options, logger = null) {
        super(options, logger);
        throw new Error("Authenticator is not supported in-browser");
    }
    async authenticate() {
        throw new Error("Authenticator is not supported in-browser");
    }
}
exports.Authenticator = Authenticator;
